// src/utils/normalizeSchema.js

// strip accidental wrapping quotes if your early seed had them
const clean = (s) => String(s ?? "").replace(/^"+|"+$/g, "").trim();

// src/utils/normalizeSchema.js
export function dbItemToPreset(item) {
  const id = clean(item.schemaId) || clean(item.id) || cryptoSafeId(item.name);
  const label = item.name || id;
  const version = Number(item.version ?? 1);

  const def = item.definition || {};
  const isRich = def && typeof def === "object" &&
    (def.mappingSrcToCanon || def.aliases || def.valueMaps || def.requiredCanon || def.optionalCanon);

  const mappingSrcToCanon = (isRich ? def.mappingSrcToCanon : def) || {};
  const aliases = (isRich ? def.aliases : item.aliases) || {};
  const valueMaps = (isRich ? def.valueMaps : item.valueMaps) || {};

  const platform = item.platform ?? def.platform ?? "x";

  const requiredCanon =
    item.requiredCanon ??
    (isRich ? def.requiredCanon : null) ??
    ["Message", "SenderScreenName", "CreatedTime"];

  const optionalCanon =
    item.optionalCanon ??
    (isRich ? def.optionalCanon : null) ??
    []; // fallback if not provided

  return {
    id,
    label,
    version,
    platform,
    requiredCanon,
    optionalCanon,          // <-- add this line
    mappingSrcToCanon,
    aliases,
    valueMaps,
  };
}

// fallback id if neither schemaId nor id exist
function cryptoSafeId(name) {
  try {
    return (
      "schema-" +
      (name || "")
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "") || "untitled"
    );
  } catch {
    return "schema-" + Math.random().toString(36).slice(2);
  }
}
